import { object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

// Definimos el límite máximo de caracteres
const MAX_LENGTH = 255;

export default () => {
    const { REQUIRED_TEXT } = getValidationTexts();

    return object().shape({
        message: string()
            .required(REQUIRED_TEXT)
            .max(MAX_LENGTH, `No puede exceder los ${MAX_LENGTH} caracteres`),
    });
};
